module.exports = __webpack_public_path__ + "components/country-flag/static/rs-852035a9390fb405407ff66bd986b0ec.svg";